module.exports = __webpack_public_path__ + "static/media/no-notifications.2cb6e9a8.svg";